import { CSSProperties } from "react";

interface TenantAvatarProps {
  logoUrl?: string | null;
  name?: string;
  size?: number;
  /** Circle (sidebar) vs rounded square (accounts list, default). */
  circle?: boolean;
  className?: string;
  testId?: string;
}

// Square logo for a tenant/account, or its name's first letter when no logo is
// set — replaces the old "NO" placeholder image (UP-2982).
export function TenantAvatar({
  logoUrl,
  name = "",
  size = 36,
  circle = false,
  className,
  testId,
}: TenantAvatarProps) {
  const base: CSSProperties = {
    width: size,
    height: size,
    borderRadius: circle ? "50%" : 8,
    flexShrink: 0,
  };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={name}
        className={className}
        data-testid={testId}
        style={{ ...base, objectFit: "contain" }}
      />
    );
  }

  // First letter on the shared #e2dee8 / white bold avatar style, matching the
  // sidebar own-tenant initial tile (logoInitial) used for therapists/admins.
  const initial = (name.trim().charAt(0) || "?").toUpperCase();
  return (
    <div
      className={className}
      role="img"
      aria-label={name || undefined}
      data-testid={testId}
      style={{
        ...base,
        background: "#e2dee8",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: Math.round(size * 0.45),
      }}
    >
      {initial}
    </div>
  );
}

export default TenantAvatar;
